<script>
import cn from 'classnames';
import { ColorTypes } from '@/constants/enums';
export default {
  name: 'Copy',
  props: {
    element: {
      type: String,
      default: 'p',
      validator: (val) => ['p', 'span', 'strong', 'div'].includes(val),
    },
    size: {
      type: String,
      default: 'm',
      validator: (val) => ['s', 'm', 'l', 'xl'].includes(val),
    },
    color: {
      type: String,
      default: 'tertiaryDark',
      validator: (val) => ColorTypes.includes(val),
    },
    bold: Boolean,
    centered: Boolean,
    underlined: Boolean,
    right: Boolean,
    noWrap: Boolean,
    responsive: Boolean,
    staticClass: String,
    onClick: Function,
  },
  data() {
    return {
      el: 'o-copy',
      classes: () => {
        const el = this.el;
        return cn({
          [el]: true,
          [`${el}--${this.size}`]: this.size,
          [`${el}--bold`]: this.bold,
          [`${el}--centered`]: this.centered,
          [`${el}--underlined`]: this.underlined,
          [`${el}--right`]: this.right,
          [`${el}--noWrap`]: this.noWrap,
          [`${el}--paragraph`]: this.element === 'p',
          [`${el}--responsive`]: this.responsive,
          [`${el}--${this.color}`]: this.color,
          [`${this.staticClass}`]: this.staticClass,
        });
      },
    };
  },
  render(createElement) {
    return createElement(
      this.element,
      {
        attrs: { class: this.classes() },
      },
      this.$slots.default
    );
  },
};
</script>
